export default __webpack_public_path__ + "static/media/Bryan.Williams.6e5d23de.JPG";